import React, { useState, useContext } from 'react'
import Select from 'react-select'
import { api } from '../api/axios';
import { toast } from 'react-toastify';
import { AuthContext } from '../context/AuthContext';

const userPermissionsdata = [
    { value: 'ads', label: 'Ads' },
    { value: 'updates', label: 'Updates' },
    { value: 'feed', label: 'Feed' },
    { value: 'users', label: 'Users' },
    { value: 'breakingnews', label: 'Breaking News' },
    { value: 'polls', label: 'Polls' },
    { value: 'meetings', label: 'Meetings' },
]

export default function AdminForm() {
    const { setLoading } = useContext(AuthContext);

    const [userPermissions, setUserpermissions] = useState([]);
    const [inputUserPermission, setInputUserPermissions] = useState()


    const handelRegisterNewUser = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target)

        setLoading(true)

        const name = formData.get('name')
        const username = formData.get('username')
        const password = formData.get('password')
        const isSuperAdmin = formData.get('superAdmin') === 'yes' ? true : false

        try {
            const respons = await api.post('/admin', {
                name,
                username,
                password,
                isSuperAdmin,
                permission: userPermissions
            })

            if (respons.status === 201) {
                return toast.success("User created successfully")
            }
        } catch (error) {
            if (error.status === 409) {
                return toast.error(error.response.data.error.details)
            }
            toast.error("Registration Error")
            console.error("Creating User Error:", error);
        } finally {
            setLoading(false)
        }
    }

    const handelPermission = async (e) => {
        const permission = e.map(({ value }) => value)
        setUserpermissions(await permission)
        setInputUserPermissions(e)
    }

    return (
        <form onSubmit={handelRegisterNewUser}>
            <div className="border-b border-gray-900/10 pb-4 mb-4">
                <h2 className="text-base font-semibold text-gray-900">Personal Information</h2>

                <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 ms-5">
                    <div className="sm:col-span-2">
                        <label htmlFor="name" className="block text-sm/6 font-medium text-gray-900">
                            Full Name
                        </label>
                        <div className="mt-2">
                            <input
                                id="name"
                                name="name"
                                type="text"
                                autoComplete="given-name"
                                className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                            />
                        </div>
                    </div>

                    <div className="sm:col-span-1">
                        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900">
                            Username
                        </label>
                        <div className="mt-2">
                            <input
                                id="username"
                                name="username"
                                type="text"
                                autoComplete="username"
                                className=" px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                            />
                        </div>
                    </div>

                    <div className="sm:col-span-2">
                        <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                            Password
                        </label>
                        <div className="mt-2">
                            <input
                                id="password"
                                name="password"
                                type="text"
                                autoComplete="password"
                                className=" px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                            />
                        </div>
                    </div>

                    <div className="sm:col-span-1">
                        <label htmlFor="superAdmin" className="block text-sm/6 font-medium text-gray-900">
                            Super Admin
                        </label>
                        <div className="mt-2">
                            <select
                                id="superAdmin"
                                name="superAdmin"
                                autoComplete="country-name"
                                defaultValue={'no'}
                                className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:max-w-xs sm:text-sm/6"
                            >
                                <option value={'no'}>No</option>
                                <option value={'yes'}>Yes</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="mt-5 space-y-5">
                    <legend className="text-sm font-semibold text-gray-900">User Permission</legend>
                    <div className="ms-5">
                        <Select
                            value={inputUserPermission}
                            isMulti
                            name="userPermissions"
                            options={userPermissionsdata}
                            onChange={handelPermission}
                            className="basic-multi-select"
                            classNamePrefix="select "
                        />
                    </div>

                </div>

                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <button
                        type="submit"
                        className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                    >
                        Save New Admin
                    </button>
                </div>
            </div>



        </form>
    )
}
